module.exports = __webpack_public_path__ + "img/earthquake.79bd622c.svg";